<script setup lang="ts">
import { OrganizationSelector } from '@rfc/rfc-components-library'
import type { UserModel } from '@rfc/rfc-components-library/types'
type Props = {
    filters?: UserModel
}
defineProps<Props>()
type Emits = {
    (e: 'change', value?: Record<string, unknown>): void
}
defineEmits<Emits>()
</script>

<template>
    <OrganizationSelector
        :organizationId="filters?.organization_id"
        @select="$emit('change', { organization_id: $event?.id })" />
</template>
